import { Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { homeShowcase } from "@/lib/siteConfig";

// Alternating wide media + text blocks. Calm reveals, soft image zoom on hover,
// a small floating stat card for editorial rhythm. Stacks cleanly on mobile.
export const MediaShowcase = () => {
  return (
    <div className="space-y-16 lg:space-y-24" data-testid="home-media-showcase">
      {homeShowcase.map((b) => (
        <div
          key={b.id}
          className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16"
        >
          {/* Media */}
          <Reveal
            className={`relative ${b.reverse ? "lg:order-2" : "lg:order-1"}`}
            y={24}
          >
            <div className="az-media-zoom az-service-frame relative overflow-hidden rounded-3xl shadow-[var(--shadow-card)]">
              <img
                src={b.image}
                alt={b.alt}
                loading="lazy"
                className="h-[340px] w-full object-cover sm:h-[420px] lg:h-[500px]"
              />
            </div>
            {b.stat && (
              <div className="absolute -bottom-6 left-6 hidden rounded-2xl border border-[#D5DEE8] bg-white px-5 py-4 shadow-[var(--shadow-card)] sm:block">
                <span className="block font-heading text-3xl font-bold text-[#7A1516]">
                  {b.stat.value}
                </span>
                <span className="text-sm text-[#586576]">{b.stat.label}</span>
              </div>
            )}
          </Reveal>

          {/* Text */}
          <div className={b.reverse ? "lg:order-1" : "lg:order-2"}>
            <Reveal>
              <span className="az-eyebrow mb-3">
                <span className="inline-block h-px w-6 bg-current" />
                {b.eyebrow}
              </span>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-heading text-3xl font-semibold leading-[1.12] tracking-[-0.01em] text-[#193D6D] sm:text-4xl lg:text-[2.6rem]">
                {b.title}
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-4 text-lg leading-relaxed text-[#586576]">{b.text}</p>
            </Reveal>
            <Reveal delay={0.15}>
              <ul className="mt-6 grid gap-3 sm:grid-cols-2">
                {b.bullets.map((t) => (
                  <li key={t} className="flex items-start gap-3 text-[#2f3a49]">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#7A1516]/[0.1] text-[#7A1516]">
                      <Check size={14} />
                    </span>
                    <span className="[overflow-wrap:anywhere]">{t}</span>
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>
        </div>
      ))}
    </div>
  );
};
